import BaseRepository from "../../../common/repository/base_repository";
import ResetPasswordModel from "../model/reset_password_model";

export default class ResetPasswordRepository extends BaseRepository {

    itemUrl = '/api/login/reset-password';
    modelClass = ResetPasswordModel;

}